import { z } from 'zod';

import { idSchema } from './utils';

export type Installation = z.infer<typeof installationSchema>;
export const installationSchema = z.object({
  installationId: z.number(),
  projectId: z.number(),
  name: z.string(),
  status: z.string(),
  plan: z.string(),
  zoom: z.number(),
  sortOrder: z.number(),
});

export type InstallationPathParams = z.infer<typeof installationPathParamsSchema>;
export const installationPathParamsSchema = z.object({
  projectId: idSchema('projectId'),
  installationId: idSchema('installationId'),
});

export type UpdateInstallationBody = z.infer<typeof updateInstallationBodySchema>;
export const updateInstallationBodySchema = z.object({
  name: z.string().max(100).optional(),
  status: z.string().max(16).optional(),
  zoom: z.number().optional(),
});
